const VIC_METRO_COUNCILS = [
    'BANYULE',
    'BAYSIDE',
    'BOROONDARA',
    'BRIMBANK',
    'CARDINIA',
    'CASEY',
    'DAREBIN',
    'FRANKSTON',
    'GLEN EIRA',
    'GREATER DANDENONG',
    'HOBSONS BAY',
    'HUME',
    'KINGSTON',
    'KNOX',
    'MANNINGHAM',
    'MARIBYRNONG',
    'MAROONDAH',
    'MELBOURNE',
    'MELTON',
    'MONASH',
    'MOONEE VALLEY',
    'MORELAND',
    'MERRI-BEK', // New name of Moreland
    'MORNINGTON PENINSULA',
    'NILLUMBIK',
    'PORT PHILLIP',
    'STONNINGTON',
    'WHITEHORSE',
    'WHITTLESEA',
    'WYNDHAM',
    'YARRA',
    'YARRA RANGES'
];

export default VIC_METRO_COUNCILS;
